import { Accordion } from '@iwoca/orion';

import styles from './DocRequirementsDE.module.css';
import { useSplitTestBranch } from '../../../api/lendingApi/lendingApiQueries';
import { ISOLATED_SPLIT_TESTS } from '../../../constants';

export const DocRequirementsDE = () => {
  const { splitTestBranch } = useSplitTestBranch(
    ISOLATED_SPLIT_TESTS.DE_6M_PDF_BS_TEST,
    { enabled: true, cookieOverride: true },
  );
  const bankStatementDays = splitTestBranch === 'INCLUDE' ? 180 : 90;

  return (
    <Accordion
      small
      title="Folgende Unterlagen brauchen wir für die jeweiligen Kredithöhen"
      className={styles.accordion}
    >
      <>
        <h2>1.000 € - 50.000 €</h2>
        <ul>
          <li>{`Kontoumsätze Ihres Geschäftskontos der letzten ${bankStatementDays} Tage`}</li>
        </ul>

        <h2>50.001 € - 500.000 €</h2>

        <ul>
          <li>{`Kontoumsätze Ihres Geschäftskontos der letzten ${bankStatementDays} Tage`}</li>
          <li>BWA und SuSa der letzten beiden Geschäftsjahre</li>
          <li>Aktuelle BWA und SuSa (nicht älter als 4 Monate)</li>
        </ul>

        <h2>Tipps</h2>
        <ul>
          <li>EÜR ersetzen die BWA</li>
          <li>Jahresabschlüsse ersetzen BWA und SuSa</li>
        </ul>
      </>
    </Accordion>
  );
};
